import ArrayFind from 'array.prototype.find';
import ArrayIncludes from 'array-includes';
import Vue from 'vue';

Vue.config.optionMergeStrategies.fetch = (fromVal, toVal) => {
  if (!toVal) return fromVal;
  if (!fromVal) return toVal;
  return async ctx => {
    await Promise.all([fromVal(ctx), toVal(ctx)]);
    return true;
  };
};

ArrayFind.shim();
ArrayIncludes.shim();
